export const NotificationLabels = {
  1: "New profiles",
  2: "New matches",
  3: "Blogs",
  4: "Success stories",
  5: "Messages / calls",
  6: "Plan expired",
  7: "Interest",
  8: "Zoom meeting invite",
  9: "Zoom meeting ended",
  10: "Interest sent",
  11: "Interest accepted",
  12: "Album request accepted",
  13: "Album request sent",
  14: "Contact request accepted",
  15: "Contact request sent",
  16: "Zoom participant rejected",
  17: "Zoom meeting rejected",
  18: "Diwali notification",
  19: "Christmas notification",
  20: "Holi notification",
  21: "Dussehra notification",
  22: "Doctors notification",
  23: "Teachers notification",
  24: "Mens notification",
  25: "Womens notification",
  26: "Profile view notification",
  27: "Total profile views",
  28: "Profile completion reminder",
  29: "Image upload reminder",
  30: "Plan expiring in two days",
};
